export enum GeometryType {
  POINT = 'Point',
  POLYGON = 'Polygon',
  MULTI_POLYGON = 'MultiPolygon',
  NULL = 'Null',
}

export type Geometry =
  | { type: GeometryType.POINT; coordinates: google.maps.LatLngLiteral }
  | { type: GeometryType.POLYGON; coordinates: google.maps.LatLngLiteral[][] }
  | {
      type: GeometryType.MULTI_POLYGON;
      coordinates: google.maps.LatLngLiteral[][][];
    }
  | { type: GeometryType.NULL };
